import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Image, ShoppingBag, Phone, Briefcase, User, Star, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const MobileBottomNav: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const navItems = [
    {
      icon: Home,
      label: t('nav.home'),
      path: '/',
    },
    {
      icon: User,
      label: t('nav.about'),
      path: '/about',
    },
    {
      icon: Image,
      label: t('nav.portfolio'),
      path: '/portfolio',
    },
    {
      icon: Star,
      label: t('nav.reviews'),
      path: '/reviews',
    },
    {
      icon: Briefcase,
      label: t('nav.forBusiness'),
      path: '/for-business',
    },
    {
      icon: Heart,
      label: t('nav.charity'),
      path: '/charity',
    }
  ];

  return (
    <nav
      className="mobile-nav-fixed fixed bottom-6 left-0 right-0 z-50 md:hidden mx-auto"
      style={{
        zIndex: 9999,
        width: '100%',
        paddingLeft: '16px',
        paddingRight: '16px'
      }}
    >
      {/* Minimalist pill-style background */}
      <div className="bg-white/80 backdrop-blur-xl border border-white/40 shadow-lg rounded-full overflow-hidden">
        <div
          className="flex items-center justify-around px-2 py-2"
          style={{
            background: 'linear-gradient(180deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.7) 100%)',
          }}
        >
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`relative flex items-center justify-center px-3 py-2 rounded-full transition-all duration-300 ${
                  isActive
                    ? 'bg-[#b91c1c]/10'
                    : 'hover:bg-gray-100/50'
                }`}
              >
                {/* Icon and label container */}
                <div className="flex items-center gap-1.5">
                  <div className={`transition-all duration-300 ${
                    isActive
                      ? 'text-[#b91c1c] scale-105'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}>
                    <Icon className="w-4 h-4" strokeWidth={isActive ? 2.5 : 2} />
                  </div>

                  {/* Show label only for active page */}
                  {isActive && (
                    <span className="text-[10px] transition-all duration-300 font-medium text-[#b91c1c] opacity-100">
                      {item.label}
                    </span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
